import { render, staticRenderFns } from "./YReplaceIp.vue?vue&type=template&id=1e28cede"
import script from "./YReplaceIp.vue?vue&type=script&lang=js"
export * from "./YReplaceIp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports